import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/sponsorship",
    name: "Sponsorship",
    component: () =>
      import(/* webpackChunkName: "sponsor" */ "../views/Sponsorship.vue"),
  },
  {
    path: "/system",
    name: "System",
    component: () =>
      import(/* webpackChunkName: "system" */ "../views/System.vue"),
  },
  {
    path: "/agenda",
    name: "Agenda",
    component: () =>
      import(/* webpackChunkName: "agenda" */ "../views/Agenda.vue"),
  },
  {
    path: "/venue",
    name: "Venue",
    component: () =>
      import(/* webpackChunkName: "venue" */ "../views/Venue.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 如果你的連結是帶 # 這種
    // to.hash 就會有值(值就是連結)
    // 例如 #3
    if (!to.params.view) {
      return { x: 0, y: 0 }
    }
  }
});

export default router;
